module.exports = __webpack_public_path__ + "img/main_05_product_img_02@2x.bd3b0a6d.png";